var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"no-border mt-3",attrs:{"no-body":""}},[_c('company-table',{attrs:{"type":"CUSTOMER","detail-url":"/shipment_md/customers/","label":"customer"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-525c7b84","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/shipment_md/customers/List.vue
// module id = 1736
// module chunks = 0 1